// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__OWglF","approved":"Status_approved__1Xp--","rejected":"Status_rejected__3UGRT","expired":"Status_expired__BLiyw","label":"Status_label__3qG38"};